<template >
  <div>
      <vs-row v-for="customerField in company_customize_field" :key="customerField.id">
        <vs-col class="flex items-center" vs-w="3">
          <span>{{customerField.field_name}}</span>
        </vs-col>
        <vs-col vs-w="9" class="flex flex-wrap ml-0">
          <template v-if="companyAction == 1">
            <vs-input v-if="customerField.field_type == 1" type="number" v-model="customerField.value" maxlength="256" :placeholder="customerField.value ? '' : customerField.field_name" class="w-full mb-2"/>
            <flat-pickr v-else-if="customerField.field_type == 2"
                      class="w-full flatpickr-style mb-2"
                      v-model="customerField.value"
                      :placeholder="customerField.value ? '' : customerField.field_name"
                      :config="datetimeConfig">
            </flat-pickr>
            <vs-input v-else type="text" v-model="customerField.value" maxlength="256" :placeholder="customerField.value ? '' : customerField.field_name" class="w-full mb-2"/>
          </template>
          <template v-else>
            <vs-input disabled v-if="customerField.field_type == 1" type="number" v-model="customerField.value" maxlength="256" :placeholder="customerField.value ? '' : customerField.field_name" class="w-3/4 mb-2"/>
            <flat-pickr v-else-if="customerField.field_type == 2" disabled
                      class="w-3/4 flatpickr-style mb-2"
                      v-model="customerField.value"
                      :placeholder="customerField.value ? '' : customerField.field_name"
                      :config="datetimeConfig">
            </flat-pickr>
            <vs-input disabled v-else type="text" v-model="customerField.value" maxlength="256" :placeholder="customerField.value ? '' : customerField.field_name" class="w-3/4 mb-2"/>
          </template>
          <vs-button v-if="companyAction != 1" @click="actEdit(customerField)" class="mx-2" color="warning"  type="border" icon="edit"></vs-button>
          <vs-button v-if="companyAction != 1" @click="actDelete(customerField)" color="danger" type="border" icon="delete"></vs-button>
        </vs-col>
      </vs-row>
    <vs-popup style="z-index: 99999" :title="`項目名情報更新`" :active="editFieldNameDiaLog" button-close-hidden>
      <vx-card title="項目名情報更新"
               card-background ="rgb(240, 238, 241)"
               height="420px"
               class="pb-2"
               style="font-size: 12px">
        <vs-row>
          <vs-col vs-w="12">
            <vs-row>
              <vs-col class="flex items-center" vs-w="3">
                <span>項目名<span style="color: red">*</span></span>
              </vs-col>
              <vs-col vs-w="9">
                <vs-input maxlength="64" v-model="customerFieldEdit.field_name" class="w-full mb-2" placeholder="項目名"/>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-w="3"></vs-col>
              <vs-col vs-w="9">
                <span v-show="fieldNameValidate" class="mb-2 text-danger font-size-info" style="display: block;">項目名は必須です。</span>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vx-card>
      <div style="display: flex; justify-content: flex-end" class="pt-4">
        <vs-button @click="updateFieldName" :disabled="fieldNameValidate" icon="settings" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
        <vs-button @click="cancelUpdateOrDelete" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
      </div>
    </vs-popup>
    <vs-popup style="z-index: 99999" :title="`項目の削除`" :active.sync="confirmDeleteDialog" button-close-hidden>
      <span>選択した項目を削除しますか？</span>
      <div style="display: flex; justify-content: flex-end" class="pt-4">
        <vs-button @click="deleteField" icon="delete" color="danger" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
        <vs-button @click="cancelUpdateOrDelete" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default {
  components:{
    flatPickr,
  },
  props:{
    customerFieldsByCompany: Array,
    companyAction: Number, // 0: normal, 1: editing
  },
  data(){
    return{
      editFieldNameDiaLog: false,
      confirmDeleteDialog: false,
      customerFieldEdit: {
        id: null,
        field_name: '',
      },
      customizeFieds: [],
      submited: false,
      datetimeConfig:{
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
      },
    }
  },
  computed:{
    fieldNameValidate(){
      return this.customerFieldEdit.field_name.length < 1 && this.submited;
    },
    company_customize_field:{
      get(){
        this.customizeFieds = this.customerFieldsByCompany;
        return this.customizeFieds;
      },
    },
  },
  methods:{
    ...mapActions({
      updateCustomFieldName: 'customer/updateFieldNameCompanyCustomize',
      deleteCustomerField: 'customer/deleteFieldNameCompanyCustomize',
    }),
    actEdit(customerField){
      this.editFieldNameDiaLog = true;
      this.customerFieldEdit.id = customerField.id;
      this.customerFieldEdit.field_name = customerField.field_name;
    },
    actDelete(customerField){
      this.confirmDeleteDialog = true;
      this.customerFieldEdit.id = customerField.id;
    },
    async updateFieldName(){
      this.submited = true;
      if(!this.fieldNameValidate){
        //update field name
        await this.updateCustomFieldName(this.customerFieldEdit);
        this.cancelUpdateOrDelete();
        this.$emit('fetchFieldsList');
      }
    },
    async deleteField(){
      await this.deleteCustomerField(this.customerFieldEdit.id);
      this.cancelUpdateOrDelete();
      this.$emit('fetchFieldsList');

    },
    cancelUpdateOrDelete(){
      this.editFieldNameDiaLog = false;
      this.customerFieldEdit = {
        id: null,
        field_name: ''
      }
      this.submited = false;
      this.confirmDeleteDialog = false;
    },
  },
  mounted() {
  },
}


</script>

<style scoped>

</style>
